import { Component } from "react";
import * as React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { RootState } from "../../core/reducers";
import { actionChangeCollapsed } from "../../core/actions/style";
import { actionLogoutSuccess } from "../../core/actions/user";
import { Layout, Icon, Menu, Dropdown, Avatar, Drawer, BackTop } from "antd";
import { withRouter, RouteComponentProps } from "react-router-dom";
import Breadcrumb from "./breadcrumb";
import routes from "../../assets/javascripts/routes";
import RouteWithSubRoutes from "./routeWithSubRoutes";
import Redirect from "./404";
import SiderNav from "./siderNav";
import menuData from "../../assets/javascripts/menu";

interface StateProps {
  collapsed: boolean;
}

interface DispatchProps {
  changeCollapsed(collapsed: boolean): void;
  logout(loginStatus: boolean): void;
}

const { Header, Content, Footer } = Layout;
const MenuItem = Menu.Item;

type PropsType = RouteComponentProps & StateProps;
class MainContent extends Component<PropsType & DispatchProps> {
  constructor(props) {
    super(props);
  }

  toggle = () => {
    let ua = navigator.userAgent.toLocaleLowerCase();
    let isMobile = /mobi/i.test(ua);
    if (isMobile) {
      this.showDrawer();
    } else {
      let collapsed = !this.props.collapsed;
      this.props.changeCollapsed(collapsed);
    }
  };

  isHasPath = () => {
    const { history } = this.props;
    let pathname = history.location.pathname;
    let flag = false;
    menuData.map((item, index) => {
      if (pathname.search(item.key) !== -1) {
        flag = true;
      }
    });
    return flag;
  };

  onClick = ({ key }: { key }) => {
    const { history } = this.props;
    switch (key) {
      case "1":
        history.push(this.state.url);
        localStorage.removeItem("accessToken");
        localStorage.removeItem("organizationId");
        localStorage.removeItem("status");
        this.props.logout(false);
        break;
      default:
        break;
    }
  };

  state = {
    visible: false,
    url: "/login",
  };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    let isNot404 = this.isHasPath();
    const menu = (
      <Menu onClick={this.onClick}>
        <MenuItem key="1">
          <Icon type="logout" />
          退出登录
        </MenuItem>
      </Menu>
    );
    let ua = navigator.userAgent.toLocaleLowerCase();
    let isMobile = /mobi/i.test(ua);
    // const contentRef  = React.createRef();
    return (
      <Layout hasSider={false}>
        <div className="backtop">
          <Header className="header">
            <Icon
              type={this.props.collapsed ? "menu-unfold" : "menu-fold"}
              onClick={this.toggle}
            />
            <Dropdown overlay={menu}>
              <a href="#">
                <Avatar icon="user" />
                <span className="header-right">退出</span>
              </a>
            </Dropdown>
            {isMobile ? (
              <div className="drawer-sider-menu screen-xs">
                <Drawer
                  width={216}
                  placement="left"
                  closable={false}
                  onClose={this.onClose}
                  visible={this.state.visible}
                  className="drawer-sider-menu screen-xs"
                >
                  <SiderNav />
                </Drawer>
              </div>
            ) : null}
          </Header>
          <Content>
            {!isNot404 ? <Redirect /> : <Breadcrumb />}
            <div>
              {routes.map((route, i) => {
                if (route.authorized) {
                  if (!isNot404) return;
                  return <RouteWithSubRoutes key={i} {...route} />;
                } else return;
              })}
            </div>
          </Content>
          <Footer></Footer>
        </div>
        <BackTop
        // target={() => contentRef.current}
        />
      </Layout>
    );
  }
}

function mapStateToProps(state: RootState): StateProps {
  return {
    collapsed: state.style.collapsed,
  };
}

function mapDispatchToProps(
  dispatch: ThunkDispatch<RootState, null, AnyAction>
): DispatchProps {
  return {
    changeCollapsed: (collapsed: boolean) => {
      dispatch(
        actionChangeCollapsed({
          collapsed: collapsed,
        })
      );
    },
    logout: (loginStatus: boolean) => {
      dispatch(
        actionLogoutSuccess({
          loginStatus: loginStatus,
        })
      );
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MainContent) as any
);
